/*
Poornima 09/19/2022 2700912712 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
akhila 10/27/2022 2701012930  bre UX Changes
suresh peddavoora 10/28/2022 2701012930  Added Styles for text fields and accordion card
Ashraf 15/16/2022 2701012930 fixed role access

*/
import React, {useEffect, useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddFilterRuleGroup from '../FilterComponents/index';
import SearchRuleGroup from './SearchRuleGroup';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import {fetchFilterRuleGroup} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch} from 'react-redux';
import FilterRuleGroupUsage from './SearchRuleGroup/FilterRuleGroupUsage';

const useStyles = makeStyles((theme) => ({
  'root': {
    'flexGrow': 1,
    'width': '100%',
    'borderRadius': '5px',
    '& .MuiCard-root': {
      boxShadow: 'none !important',
    },
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs({
  setNewLetter,
  letter,
  newLetter,
  searchLetter,
  setTableData,
  setCode,
  code,
  groupId,
  RMbreCode,
  setTabValue,
}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const [breCode, setBreCode] = useState(null);
  const [dataReset, setResetData] = useState('');
  const [rowdata, setRowData] = useState(null);
  const {editRuleGroupId, setEditRuleGroupId} = useContext(SelectTabContextProvider);
  const [rowSelected, setRowSelected] = useState(false);

  useEffect(() => {
    if (editRuleGroupId) {
      setTabValue(1);
      setValue(1);
      dispatch(fetchFilterRuleGroup(editRuleGroupId));
      setEditRuleGroupId(null);
    }
  }, []);
  useEffect(() => {
    if (groupId !== '') {
      setValue(1);
    }
  }, [groupId]);
  useEffect(() => {
    if (RMbreCode !== null) {
      setBreCode(RMbreCode);
    }
  }, [RMbreCode]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.searchRuleButton}>

        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchRuleGroup
            rowdata={rowdata}
            dataReset={dataReset}
            breCode={breCode}
            setValue={setValue}
            setBreCode={setBreCode}
            setResetData={setResetData}
            setRowSelected={setRowSelected}
            setRowData={setRowData}
          />
        ) :
          value === 1 ? (
            <AddFilterRuleGroup
              setValue={setValue}
              setBreCode={setBreCode}
              breCode={breCode}
              setTabValue={setTabValue}
              dataReset={dataReset}
              rowSelected={rowSelected}
              handleChange={handleChange}
            />
          ) :
            value === 2 ? (
              <FilterRuleGroupUsage setValue={setValue} setResetData={setResetData} rowdata={rowdata} />
            ) :
              null }
      </div>
    </div>
  );
}
